module.exports = __webpack_public_path__ + "static/img/A31.b39c92ce.jpg";